import React from 'react'
import styles from './assets/styles/bigText.styles'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(styles)

export default function BigText({ primaryText, secondaryText, textColor }) {
    const props = {
        textColor
    }
    const classes = useStyles(props)
    return (
        <div className={classes.root} >
            <h1 className={classes.h1} >{primaryText}</h1>
            <h2 className={classes.h2} >{secondaryText}</h2>
        </div>
    )
}
